import { MainApi } from "./MainApi";
import { AffiliateCodeCommissionCheckerParam, CreateOrderParam } from "../types/order";

export class OrderApi {
  static baseUrl = `${MainApi.urlPrefix}/user/orders`;

  static postOrder = (orderParam: CreateOrderParam) => () => MainApi.api.post(`${OrderApi.baseUrl}`, orderParam);

  static getOrder = (orderIdx: number) => () => MainApi.api.get(`${OrderApi.baseUrl}/${orderIdx}`);

  static getAffiliateCode = (code: string) => () =>
    MainApi.api.get(`${MainApi.urlPrefix}/affiliate-codes?code=${encodeURIComponent(code)}`);

  static checkAffiliateCodeCommission = (param: AffiliateCodeCommissionCheckerParam) => () =>
    MainApi.api.post(`${OrderApi.baseUrl}/check-affiliate-commission`, param);
}
